import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import AddMotifResolutionDialog from './AddMotifResolutionDialog';

import DeleteMotifResolutionDialog from './DeleteMotifResolutionDialog';
import { green } from '@mui/material/colors';



const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link, 
       
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },

    deleting: {
        background : 'red'
    }

});



class AdministrationMotifsResolution extends React.Component {
    

    render() {

        let {
            classes, motifsResolution,
            addMotifResolutionDialogOpen, onOpenAddDialog, onCloseAddDialog, addMotifResolution,
            deleteMotifResolutionDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteMotifResolution, motifResolutionToDelete
         } = this.props;

        return (
            <React.Fragment>

                {addMotifResolutionDialogOpen && <AddMotifResolutionDialog onClose={onCloseAddDialog} onClickSave={addMotifResolution} />}
                {deleteMotifResolutionDialogOpen && <DeleteMotifResolutionDialog onClose={onCloseDeleteDialog} onClickDelete={deleteMotifResolution} motifResolution={motifResolutionToDelete} />}


                <div className={classes.administrationHeaderContainer}>
                    <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                        Administration des motifs de résolution
                    </Typography>
                    <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouveau</Button>
                </div>

                <Paper className={classes.root}>

                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='right'>Id</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Libellé</TableCell>
                                <TableCell>Nb actions</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {motifsResolution.sort((a,b) => a.code > b.code).map(motifResolution => {
                                return (
                                    <TableRow key={motifResolution.id} className={motifResolutionToDelete && motifResolutionToDelete.id === motifResolution.id ? classes.deleting :''}
                                        hover
                                    >
                                        <TableCell component="th" scope="row" align='right'>
                                            <Link to={`/administration/motifsResolution/${motifResolution.id}`} className={classes.link}>
                                                <Typography variant="button">
                                                    {motifResolution.id}
                                                </Typography>
                                            </Link>
                                        </TableCell>
                                        <TableCell>{motifResolution.code}</TableCell>
                                        <TableCell>{motifResolution.libelle}</TableCell>
                                        <TableCell>{motifResolution.nbActions}</TableCell>
                                        <TableCell>
                                            <Button disabled={motifResolution.nbActions > 0} onClick={e => onOpenDeleteDialog(motifResolution.id)}>Supprimer</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                </Paper>

            </React.Fragment>


        );
    }
}

AdministrationMotifsResolution.propTypes = {
    classes: PropTypes.object.isRequired,
    motifsResolution: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationMotifsResolution);